import cookie from 'cookie';

const dataOrDefault = (data, defaultValue) =>
  (data === null || typeof data === 'undefined') && typeof defaultValue !== 'undefined' ? defaultValue : data;

export const getCookie = (cookieName, defaultValue) => {
  if (__CLIENT__ || __TEST__) {
    return dataOrDefault(cookie.parse(document.cookie)[cookieName], defaultValue);
  }
};

// `options` are here: https://www.npmjs.com/package/cookie#options-1
export const setCookie = (name, value, options = {}) => {
  if (__CLIENT__ || __TEST__) {
    document.cookie = cookie.serialize(name, value, options);
  }
};
